export default $axios => ({
    getSearchResults(seacrhQuery) {
        return $axios({
            method: 'GET',
            url: '/general/v2/search/search/',
            params: {
                query: seacrhQuery
            }
        });
    }
});
